<template>
  <VisaForm country="uk" :products>
    <template #visa_select="{ form }">
      <BasketFields :form :products />
      <TermsCheckbox v-model="form.termsAgreed" />
    </template>

    <template #details="{ form }">
      <ClientFields v-model="form.client" />
      <LazyApplicantInfo
        v-for="(applicant, i) in form.applicants"
        :applicant="applicant"
        :index="i"
      >
        <template #personal>
          <PassportFields v-model="applicant.passport" />
          <ExtraNationalityFields v-model="applicant.extraNationality" />
          <AddressFields v-model="applicant.address" />
          <OccupationFields v-model="applicant.occupation" />
        </template>
      </LazyApplicantInfo>
    </template>

    <template #upload />
    <template #payment />
  </VisaForm>
</template>

<script setup lang="ts">
import type { Product } from '~/types';

defineProps<{
  products: Product[];
}>();
</script>